const svg_checkmark = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path fill="#58b7b3" fill-rule="evenodd" d="M7.5 0A7.507 7.507 0 0 0 0 7.5C0 11.637 3.363 15 7.5 15c4.137 0 7.5-3.363 7.5-7.5C15 3.363 11.637 0 7.5 0zm4.358 5.953l-4.816 4.815a.562.562 0 0 1-.395.174.567.567 0 0 1-.395-.174L3.6 8.116a.572.572 0 0 1 0-.805.571.571 0 0 1 .806 0l2.241 2.241 4.421-4.42a.571.571 0 0 1 .806 0c.205.236.205.6-.016.821z"></path></svg>';
const svg_xmark = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15"><path fill="#565656" fill-rule="evenodd" d="M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm3.271 9.956a.576.576 0 0 1-.815.815L7.5 8.314l-2.457 2.457a.576.576 0 0 1-.814-.815L6.685 7.5 4.229 5.043a.575.575 0 1 1 .814-.814L7.5 6.686l2.456-2.457a.576.576 0 0 1 .815.814L8.314 7.5l2.457 2.456z"></path></svg>';
/*
* See In Store feature for the PDP
* Displays the product's availability in nearby stores, and the availability of similar products
*/

/*
* Gets the customer's nearby stores from yext
* Documentation: https://hitchhikers.yext.com/docs/contentdeliveryapis/legacy/entities
* Example request URL: https://cdn.yextapis.com/v2/accounts/me/entities/geosearch?api_key=d19a7bf02d89e1718835a43d3cea0c77&v=20240402&location="50047"&radius=30&limit=5
*/
function getNearbyStoresSIS() {
  const yextEndpoint = "https://cdn.yextapis.com/v2/accounts/me/entities/geosearch";
  const yextApiKey = "d19a7bf02d89e1718835a43d3cea0c77";
  const version = "20240402";
  let url = yextEndpoint +
    "?api_key=" + yextApiKey +
    "&v=" + version +
    "&location=" + window.slumberland.customer.zipCode +
    "&radius=" + 30 +
    "&limit=" + 5;

  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      const event = new CustomEvent("yext:nearby_stores_available_sis", { detail: this.responseText });
      document.dispatchEvent(event);
    }
  }
  xhttp.open("GET", url);
  xhttp.send();
}

function renderSimilarProduct(sku_data, store_url, current_store, elSimilarNearYou, elSimilarH4) {
  const product_id = sku_data.split('|')[1];
  const product_sku = sku_data.split('|')[0];
  const product_sku_length = product_sku.length;



  async function fetchData() {
    try {
      // Step 1: Run the first fetch request
      const response1 = await fetch('https://slumberlandstore.myshopify.com/api/2024-07/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'e44500b59a428ff8d1d7f863efca9231',
          'Shopify-Storefront-Buyer-IP': window.slumberland.customer.ip
        },
        body: JSON.stringify({
          query: `
            query {
              product(id: "gid://shopify/Product/${product_id}") {
                title
                onlineStoreUrl
                featuredImage {
                    altText
                    url
                }
              }
            }
          `
        })
      });
      const data1 = await response1.json();

      // Check if the first request was successful
      if (!response1.ok) {
        throw new Error(`First fetch failed: ${response1.statusText}`);
      }

      // Step 2: Use data1 to run the second fetch request
      const response2 = await fetch('https://slumberlandstore.myshopify.com/api/2024-07/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': 'e44500b59a428ff8d1d7f863efca9231',
          'Shopify-Storefront-Buyer-IP': window.slumberland.customer.ip
        },
        body: JSON.stringify({
          query: `
            query {
              product(id: "gid://shopify/Product/${product_id}") {
                id
                title
                images(first: 20) {
                  edges {
                    node {
                      id
                      altText
                      url
                    }
                  }
                }
              }
            }
          `
        })
      });
      const data2 = await response2.json();

      // Check if the second request was successful
      if (!response2.ok) {
        throw new Error(`Second fetch failed: ${response2.statusText}`);
      }

      // Step 3: Return both responses
      return { response1: data1, response2: data2 };

    } catch (error) {
      // Handle any errors that occurred during the fetch operations
      console.error('Error occurred:', error);
      throw error; // Rethrow the error if you want to handle it further up the call stack
    }
  }

  // Example usage
  fetchData().then(result => {
    const store_city = current_store.geo_id.split(',')[0].trim();
    const on_display_lbl = elSimilarNearYou.getAttribute('data-on-display-lbl');
    const img_url = result.response1.data.product.featuredImage ? result.response1.data.product.featuredImage.url : '';
    const alt_txt2 = result.response1.data.product.featuredImage ? result.response1.data.product.featuredImage.altText : '';


    // Extract images from the response
    const images = result.response2.data.product.images.edges;
    const title = result.response1.data.product.title;
    const imageTitle = product_sku + alt_txt2.substring(alt_txt2.indexOf("_"), alt_txt2.length);
    const altTextToMatch = title + " - " + imageTitle;

    // Filter images to find the one with matching altText
    const matchedImage = images.find(edge => edge.node.altText === altTextToMatch);

    // Get the URL of the matched image
    const matchedImageUrl = matchedImage ? matchedImage.node.url : img_url;
    const altTextFind = matchedImage ? matchedImage.node.altText : 'No text found';

    const useThisImageUrl = matchedImageUrl ? matchedImageUrl : img_url;
    const useThisAltText = altTextToMatch ? altTextToMatch : alt_txt2;
    const storeUrl = result.response1.data.product.onlineStoreUrl;
    const useThisTitle = result.response1.data.product.title;


    elSimilarNearYou.innerHTML += `<ul>
      <li class="sis-store-name"><a href="${store_url}" target="_blank" title="${current_store.name}">${store_city}</a></li>
      <li class="similar-product-image"><img src="${useThisImageUrl}" alt="${useThisAltText}"/></li>
      <li class="similar-item-store"><a href="${storeUrl}" target="_blank" title="${useThisTitle}">${useThisTitle}</a></li>
      <li class="on-display-lbl">${svg_checkmark}&nbsp;${on_display_lbl}</li>
    </ul>`;



    if (elSimilarH4.classList.contains('hide')) {
      elSimilarH4.classList.remove('hide');
    }


  }).catch(error => {
    console.error('Error in fetching data:', error);
  });

}

/*
* Updates the See In Store modal with nearby store info
*/
function updateModal(nearbyStores) {
  let elStoresNearYou = document.getElementById('stores-near-you');
  let elSimilarNearYou = document.getElementById('similar-near-you');
  let elSimilarH4 = document.getElementById('similar-h4');

  if (nearbyStores) {
    let nearby_html = []

    for (store of nearbyStores) {
      const store_id = store.meta.id;

      // Stores Near You
      const current_store = window.slumberland.stores[store_id];
      if (current_store) {
        const store_city = current_store.geo_id.split(',')[0].trim();
        nearby_html.push(`<div class="store-near-you" data-store-id="${store_id}">
                        <div class="sis-store-name"><a href="${store.c_pagesURL}"
                        target="_blank" title="${current_store.name}">${store_city}</a></div><div class="store-display">`);

        if (current_store.on_display) {
          nearby_html.push(`<div class="on-display">${svg_checkmark}&nbsp;On Display</div>`);
        } else {
          nearby_html.push(`<div class="not-available">${svg_xmark}&nbsp;Not In Store</div>`);
        }
        // Close store html element
        nearby_html.push(`</div></div>`);

        // Similar Products (On Display) Near You
        indx = 1;
        Object.keys(window.slumberland.stores).every(function (key) {
          if (key == store_id && !current_store.on_display) {
            const _store = window.slumberland.stores[key];
            if (_store && _store.similar_skus_on_display) {
              // Get variant data for display
              let shuffled_similars_skus = _store.similar_skus_on_display.split(',').sort(() => Math.random() - 0.5);
              let similar_skus = shuffled_similars_skus.slice(0, 5);
              for (sku_data in similar_skus) {
                renderSimilarProduct(similar_skus[sku_data], store.c_pagesURL, _store, elSimilarNearYou, elSimilarH4);
              }
            }

            if (indx >= 10) {
              return false;
            }
          }
          return true;
        });
      }
    }

    if (nearby_html.length > 0) {
      elStoresNearYou.innerHTML = nearby_html.join("");
    }

  } else {
    // no stores within range (30 miles)
    elStoresNearYou.innerHTML = `<h4>${elStoresNearYou.getAttribute('data-no-stores-lbl')}</h4>`;
  }

  // Update Labels
  document.getElementById('sis-near').innerHTML = `"${window.slumberland.customer.zipCode}"`;
}

function init() {

  // yext has returned the nearby stores
  document.addEventListener("yext:nearby_stores_available_sis", (e) => {
    let nearbyStores = JSON.parse(e.detail).response.entities;
    if (nearbyStores) {
      window.slumberland.nearbyStores = nearbyStores;
      updateModal(nearbyStores);
    }
  },
    false,
  );

  // modal opened
  document.addEventListener("see_in_store:modal_opened", (e) => {
    if (!('nearbyStores' in window.slumberland) || window.slumberland.geo_changed == 1) {
      getNearbyStoresSIS();
      window.slumberland.geo_changed = 0;
    }
  },
    false,
  );

}

init();